export const delayDecomposition = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
